import { render, staticRenderFns } from "./WebViewer.vue?vue&type=template&id=1c23d0bf&"
import script from "./WebViewer.vue?vue&type=script&lang=js&"
export * from "./WebViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports